module.exports = __webpack_public_path__ + "img/ic_close_rounded_nobg.c3ebb987.svg";